var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.serviceId == 64982 ||
    _vm.serviceId == 64987 ||
    _vm.serviceId == 65064 ||
    _vm.serviceId == 65065
    ? _c(
        "a",
        {
          attrs: {
            href: "javascript:0;",
            "data-bs-toggle": "popover",
            title: _vm.getTitleText,
            "data-bs-trigger": "hover",
            "data-bs-placement": "top",
            "data-bs-custom-class": "cost-help",
            "data-bs-html": "true",
            "data-bs-content": _vm.gethelpText
          }
        },
        [_c("i", { staticClass: "fa-sharp fa-light fa-circle-info" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }